import React from 'react'
import { css, cx } from '@emotion/css'
import { theme as deprecatedTheme } from '../../styled'
import { theme } from '@contrast-security-inc/design-system-foundations'
import { CsPresenceBulletsIcon } from '../../legacy-design-system/icons'
import { FormattedMessage, FormattedTime } from 'react-intl'
import { WithTooltip, TooltipLabel } from '../../design-system'
import { Placement } from '../../legacy-design-system/popper'

const onlineCss = css`
  color: ${theme.color.green50};
`

const offlineCss = css`
  color: ${theme.color.neutral50};
`

const statusTextCss = css`
  font-family: ${deprecatedTheme.fontFamilies.secondary};
  font-size: 12px;
  font-weight: 900;
  text-transform: uppercase;
`

const statusTextOnlineCss = cx(statusTextCss, onlineCss)
const statusTextOfflineCss = cx(statusTextCss, offlineCss)

interface Props {
  readonly online: boolean
  readonly lastActivity: number
  readonly tooltipPlacement?: Placement
}

interface LabelProps {
  readonly online: boolean
  readonly children: string
}

export const presenceIndicatorTestId = 'presence-indicator-test-id'

function Label({ online, children }: LabelProps) {
  return (
    <label
      className={online ? statusTextOnlineCss : statusTextOfflineCss}
      children={children}
    />
  )
}

function TooltipContent({ online, lastActivity }: Props) {
  return (
    <div>
      <FormattedMessage
        id={online ? 'title_serverStatusOnline' : 'title_serverStatusOffline'}
        defaultMessage={online ? 'online' : 'offline'}
      >
        {(text) => <Label online={online}>{text as any}</Label>}
      </FormattedMessage>
      <FormattedMessage id="title_lastSeen_presence">
        {(label) => {
          return (
            <TooltipLabel
              label={label as any}
              renderValue={() => (
                <FormattedTime
                  value={new Date(lastActivity)}
                  month="short"
                  day="2-digit"
                  hour="2-digit"
                  minute="2-digit"
                />
              )}
            />
          )
        }}
      </FormattedMessage>
    </div>
  )
}

export function PresenceIndicator({
  online,
  lastActivity,
  tooltipPlacement
}: Props) {
  return (
    <WithTooltip
      placement={tooltipPlacement || 'right'}
      renderTooltipContent={() => (
        <TooltipContent online={online} lastActivity={lastActivity} />
      )}
    >
      {() => {
        return (
          <CsPresenceBulletsIcon
            data-testid={presenceIndicatorTestId}
            size="12"
            className={online ? onlineCss : offlineCss}
          />
        )
      }}
    </WithTooltip>
  )
}
